const notAuthSectionsTypes = {
    logosIcon: 'logosIcon',
    infoPartText: 'infoPartText',
    imageTextSection: 'imageTextSection',
    infoFeaturesText: 'infoFeaturesText',
    infoNumbers: 'infoNumbers',
    footer: 'footer',
};

export default notAuthSectionsTypes;
